import { List } from 'immutable';
import { createSelector } from 'reselect';

import type { RootReduxState } from '../../utils/types';

export interface ShopsSelection {
  shopsCount: number;
  isShopsReceived: boolean;
  isCreatingNewShop?: boolean;
}

export const selectShops = createSelector(
  (state: RootReduxState) =>
    state.getIn([
      'customerBackendDashboard',
      'userData',
      'shops',
    ]) as List<unknown>,
  (state: RootReduxState) =>
    state.getIn([
      'customerBackendDashboard',
      'userData',
      'shopsRecieved',
    ]) as boolean,
  (state: RootReduxState) =>
    state.getIn([
      'customerBackendDashboard',
      'admin',
      'storeAdministration',
      'creatingShop',
    ]) as boolean | undefined,
  (shops, isShopsReceived, isCreatingNewShop): ShopsSelection => ({
    shopsCount: shops.size,
    isShopsReceived,
    isCreatingNewShop,
  }),
);
